/* ck-infinite-scroll: opt-in auto-load of the next collection page.
   Section must render its grid wrapper with data-infinite-scroll="true"
   and id="main-collection-product-grid". The classic pagination nav
   (rendered via snippets/pagination.liquid) stays in the DOM as the
   no-JS / failure fallback; this script fetches the next page ahead of
   time and swaps the pagination nav for the freshly fetched one so the
   "next" link/state is always accurate, removing it entirely at the end. */
(function () {
  var GRID_SELECTOR = '#main-collection-product-grid[data-infinite-scroll="true"]';

  function findPaginationNav(grid) {
    // pagination.liquid renders a <nav role="navigation"> wrapping <ul class="pagination">
    // it sits just after the grid, inside the same paginate wrapper.
    var container = grid.closest('.container--large') || grid.parentElement;
    if (!container) return null;
    return container.querySelector('nav[role="navigation"]');
  }

  function makeLoader() {
    var el = document.createElement('div');
    el.className = 'ck-infinite-scroll__loading';
    el.setAttribute('aria-live', 'polite');
    el.style.cssText = 'text-align:center;padding:24px 0;font-size:14px;letter-spacing:0.02em;opacity:0.7;display:none;';
    el.textContent = 'Loading more...';
    return el;
  }

  function initGrid(grid) {
    if (!grid || grid.__ckInfiniteScroll) return;
    grid.__ckInfiniteScroll = true;

    var nav = findPaginationNav(grid);
    if (!nav) return; // no pagination at all -> single page, nothing to do

    var nextLink = nav.querySelector('.next a');
    if (!nextLink) return; // already on last (or only) page

    var isLoading = false;
    var loader = makeLoader();
    nav.parentNode.insertBefore(loader, nav);

    var sentinel = document.createElement('div');
    sentinel.className = 'ck-infinite-scroll__sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    nav.parentNode.insertBefore(sentinel, nav);

    var io;

    function stop() {
      if (io) io.disconnect();
      loader.style.display = 'none';
      if (sentinel.parentNode) sentinel.parentNode.removeChild(sentinel);
    }

    function loadNext(url) {
      if (isLoading || !url) return;
      isLoading = true;
      loader.style.display = 'block';

      fetch(url, { credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshGrid = doc.getElementById('main-collection-product-grid');
          var freshNav = freshGrid ? (freshGrid.closest('.container--large') || freshGrid.parentElement) : null;
          freshNav = freshNav ? freshNav.querySelector('nav[role="navigation"]') : doc.querySelector('nav[role="navigation"]');

          if (freshGrid) {
            var newItems = freshGrid.querySelectorAll('.product-item');
            var frag = document.createDocumentFragment();
            for (var i = 0; i < newItems.length; i++) frag.appendChild(newItems[i]);
            grid.appendChild(frag);
          }

          // Swap in the freshly-fetched pagination nav (accurate next/prev state),
          // then re-derive the next link from it.
          var newNextHref = null;
          if (freshNav) {
            nav.parentNode.replaceChild(freshNav, nav);
            nav = freshNav;
            nav.style.display = 'none';
            var freshNext = nav.querySelector('.next a');
            newNextHref = freshNext ? freshNext.getAttribute('href') : null;
          }

          isLoading = false;
          loader.style.display = 'none';

          document.dispatchEvent(new CustomEvent('collection:loaded'));
          document.dispatchEvent(new CustomEvent('ck:grid:replaced'));

          if (newNextHref) {
            // move sentinel back to just before the (new) nav so it can trigger again
            nav.parentNode.insertBefore(sentinel, nav);
            // Force the observer to re-arm: if the sentinel was still "isIntersecting"
            // at the moment it got repositioned (common once rootMargin is 600px and
            // the appended page is short), the callback only fires on a state CHANGE,
            // so it silently never re-triggers. Unobserve/re-observe resets that state.
            io.unobserve(sentinel);
            io.observe(sentinel);
          } else {
            stop();
          }
        })
        .catch(function () {
          isLoading = false;
          loader.style.display = 'none';
          // fail-safe: leave the real pagination nav visible/clickable
        });
    }

    if (!('IntersectionObserver' in window)) return; // classic pagination remains the fallback

    // JS is confirmed working - hide the numbered pagination nav now that scroll
    // takes over. It stays in the DOM (still swapped/updated on each load) purely
    // as the no-JS fallback; visually it's redundant once auto-load is running.
    nav.style.display = 'none';

    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          var link = nav.querySelector('.next a');
          loadNext(link ? link.getAttribute('href') : null);
        }
      }
    }, { root: null, rootMargin: '600px 0px 600px 0px', threshold: 0 });

    io.observe(sentinel);
  }

  function boot() {
    var grids = document.querySelectorAll(GRID_SELECTOR);
    for (var i = 0; i < grids.length; i++) initGrid(grids[i]);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
